<template>
  <div id="profile">
    <div @mouseleave="showLogout = false" class="profile">
      <div @mouseover="showLogout = true" @mouseleave="showLogout = false" class="profile__container">
        <div class="profile__container__name">{{ me.company }}</div>
        <div class="profile__container__pic">{{ me.pic }}</div>
        <transition name="topbar-bounce">
          <div v-show="showLogout" class="profile__menu__square">
            <div class="profile__menu__square__user">
              <span class="profile__menu__square__user__name">{{ me.fullname }}</span>
              <span class="profile__menu__square__user__email">{{ me.email }}</span>
            </div>
            <div @click="logout" class="profile__menu__square__logout">Cerrar Sesión</div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data () {
    return {
      showLogout: false
    }
  },
  computed: {
    me () {
      const me = this.$store.getters.me
      me.pic = me.fullname ? me.fullname[0] : ''
      return me
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style>
.topbar-bounce-enter-active {
  animation: topbar-bounce-in .3s;
}

.topbar-bounce-leave-active {
  animation: topbar-bounce-in .3s reverse;
}

@keyframes topbar-bounce-in {
  0% {
    opacity: 0;
    top: 60px;
    right: 10px;
  }
  100% {
    opacity: 1;
    top: 56.5px;
  }
}

#profile {
  width: 100%;
}

.profile {
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
  display: flex;
  flex-direction: row;
  height: 58px;
  justify-content: flex-end;
  margin-bottom: 2px;
  z-index: 9999;
}

.profile__container {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.profile__container__name {
  cursor: default;
  padding: 0 15px;
  width: auto;
}

.profile__container__pic {
  color: #ffffff;
  line-height: 35px;

  background-color: #4a90e2;
  border-radius: 50%;
  border-style: none;
  cursor: default;
  height: 35px;
  margin: 0 20px 0 0;
  width: 35px;
}

.profile__menu__square {
  background-color: #ffffff;
  border-radius: 7px;
  box-shadow: 0px 0px 4px rgba(0,0,0,0.2);
  position: absolute;
  right: 16px;
  top: 56.5px;
  width: fit-content;
  z-index: 9;
}

.profile__menu__square:after,
.profile__menu__square:before {
  border-style: solid;
  content: '';
  display: block;
  height: 0px;
  left: calc(100% - 32px);
  position: absolute;
  width: 0;
}

.profile__menu__square:after {
  border-color: transparent transparent #ffffff transparent;
  border-width: 0px 10px 10px 10px;
  top: -10px;
}

.profile__menu__square:before {
  border-color: transparent transparent rgba(0,0,0,0.05) transparent;
  border-width: 0px 10px 10px 10px;
  top: -11px;
}

.profile__menu__square__user {
  line-height: 25px;

  display: flex;
  flex-direction: column;
}

.profile__menu__square__logout {
  border-color: rgba(0,0,0,0.07);
  border-style: solid;
  border-width: 1px 0 0 0;
  cursor: pointer;
  padding: 10px 0;
}

.profile__menu__square__user__name {
  text-align: left;

  margin: 0 10px;
  width: fit-content;
}

.profile__menu__square__user__email {
  text-align: left;

  margin: 0 10px;
  width: fit-content;
}
</style>
